import React from 'react'
import { withIcon } from '../../withIcon'

function PlayIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path d="M17.725 11.4337L9.83793 6.08655C9.75319 6.02974 9.65729 5.99991 9.55972 6C9.46215 6.00009 9.36629 6.03012 9.28164 6.08709C9.19698 6.14407 9.12646 6.22602 9.07707 6.32484C9.02767 6.42366 9.0011 6.53592 9 6.6505V17.3495C9.0011 17.4641 9.02767 17.5763 9.07707 17.6752C9.12646 17.774 9.19698 17.8559 9.28164 17.9129C9.36629 17.9699 9.46215 17.9999 9.55972 18C9.65729 18.0001 9.75319 17.9703 9.83793 17.9134L17.725 12.5663C17.8088 12.5081 17.8782 12.4253 17.9264 12.326C17.9746 12.2267 18 12.1143 18 12C18 11.8857 17.9746 11.7733 17.9264 11.674C17.8782 11.5747 17.8088 11.4919 17.725 11.4337Z" fill={color}/>
    </svg>
  )
}

export default withIcon(PlayIcon)
